import { jsx } from "react/jsx-runtime";
import { useIsPagesRouter } from "../hooks/use-is-pages-router";
import Head from "next/head";
function PageTitle({ children, ...props }) {
  if (useIsPagesRouter()) {
    return /* @__PURE__ */ jsx(Head, { children: /* @__PURE__ */ jsx("title", { ...props, children }) });
  }
  return /* @__PURE__ */ jsx("title", { ...props, children });
}
function PageMeta(props) {
  if (useIsPagesRouter()) {
    return /* @__PURE__ */ jsx(Head, { children: /* @__PURE__ */ jsx("meta", { ...props }) });
  }
  return /* @__PURE__ */ jsx("meta", { ...props });
}
function PageLink({ precedence, ...props }) {
  if (useIsPagesRouter()) {
    return /* @__PURE__ */ jsx(Head, { children: /* @__PURE__ */ jsx("link", { ...props }) });
  }
  return /* @__PURE__ */ jsx("link", { ...props, precedence });
}
function PageStyle({ children, precedence, href, ...props }) {
  if (useIsPagesRouter()) {
    return /* @__PURE__ */ jsx(Head, { children: /* @__PURE__ */ jsx("style", { ...props, children }) });
  }
  return (
    // @ts-expect-error: currently react types don't include prop definitions
    // for `precedence` & `href` since it's a React Canary feature. See
    // https://react.dev/reference/react-dom/components/style#props. The
    // functionality is supported because Next.js App Router uses React Canary.
    /* @__PURE__ */ jsx("style", { ...props, precedence, href, children })
  );
}
export {
  PageLink,
  PageMeta,
  PageStyle,
  PageTitle
};
//# sourceMappingURL=head-tags.js.map